module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "manageAffiliation",
    staticClass: "manage-affiliation-modal manageAffiliation-md-dialog",
    class: {
      'show-md-dark-mode': _vm.showMode
    },
    attrs: {
      "md-open-from": "#manageAffiliation",
      "md-close-to": "#manageAffiliation"
    },
    on: {
      "open": _vm.fixContent,
      "close": _vm.startOver
    }
  }, [_c('md-dialog-title', [(_vm.confirmPurchase) ? _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Confirm Purchase")]) : _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Manage Active Users")])]), _vm._v(" "), _c('md-dialog-content', {
    staticClass: "manage-affiliation-modal-content"
  }, [(_vm.confirmPurchase) ? _c('div', {
    staticClass: "confirm-purchase-container"
  }, [_c('div', [_c('div', {
    staticClass: "confirm-text"
  }, [_vm._v("You are adding " + _vm._s(_vm.licensesToAdd) + " users at a cost of $" + _vm._s((_vm.licensesToAdd * _vm.seatPricePerYear).toFixed(2)) + " per year")]), _vm._v(" "), (_vm.purchaseWorking) ? _c('div', {
    staticClass: "purchase-progress"
  }, [_c('div', {
    staticClass: "purchase-progress-bar"
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticClass: "purchase-progress-text"
  }, [_vm._v("Contacting your bank. This can take a few seconds — please don't close this window.")])]) : _vm._e(), _vm._v(" "), (_vm.purchaseError) ? _c('p', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.purchaseError))]) : _vm._e(), _vm._v(" "), (_vm.purchaseError && _vm.purchaseErrorIsPaymentProblem) ? _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.openManageBilling
    }
  }, [_vm._v("Update payment method")]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": _vm.purchaseWorking
    },
    on: {
      "click": _vm.confirmPurchaseSubmit
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.purchaseWorking ? 'Working…' : 'Confirm') + "\n                    ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": _vm.purchaseWorking
    },
    on: {
      "click": _vm.toggleConfirmPurchase
    }
  }, [_vm._v("Cancel")])], 1)]) : _c('div', [_c('div', {
    staticClass: "edit-your-institution"
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.keyPress.apply(null, arguments)
      }
    }
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "your-institution"
    }
  }, [_vm._v("Your institution")]), _vm._v(" "), _c('md-input', {
    ref: "input_institution_name",
    attrs: {
      "required": "",
      "placeholder": "Institution Name"
    },
    model: {
      value: (_vm.institution_name),
      callback: function($$v) {
        _vm.institution_name = $$v
      },
      expression: "institution_name"
    }
  })], 1)], 1), _vm._v(" "), _c('p', [_vm._v("(This is how your collaborators will find you.)")])]), _vm._v(" "), (_vm.opened) ? _c('div', {
    staticClass: "affiliate-invite",
    class: {
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "affiliate-invite-title"
  }, [_vm._v("Invite a user to affiliate")]), _vm._v(" "), _c('div', {
    staticClass: "affiliate-invite-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inviteEmail),
      expression: "inviteEmail"
    }],
    staticClass: "affiliate-input",
    attrs: {
      "type": "email",
      "placeholder": "Email address"
    },
    domProps: {
      "value": (_vm.inviteEmail)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendInvite.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inviteEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inviteName),
      expression: "inviteName"
    }],
    staticClass: "affiliate-input",
    attrs: {
      "type": "text",
      "placeholder": "Name (optional)"
    },
    domProps: {
      "value": (_vm.inviteName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inviteName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "affiliate-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.inviting || !_vm.inviteEmail
    },
    on: {
      "click": _vm.sendInvite
    }
  }, [_vm._v("Send Invite")])]), _vm._v(" "), (_vm.inviteError) ? _c('div', {
    staticClass: "affiliate-invite-msg affiliate-invite-error"
  }, [_vm._v(_vm._s(_vm.inviteError))]) : _vm._e(), _vm._v(" "), (_vm.inviteNotice) ? _c('div', {
    staticClass: "affiliate-invite-msg affiliate-invite-notice"
  }, [_vm._v(_vm._s(_vm.inviteNotice))]) : _vm._e(), _vm._v(" "), (_vm.sentInvites.length) ? _c('div', {
    staticClass: "affiliate-pending"
  }, [_c('div', {
    staticClass: "affiliate-pending-title"
  }, [_vm._v("Pending invitations")]), _vm._v(" "), _vm._l((_vm.sentInvites), function(inv) {
    return _c('div', {
      key: inv.id,
      staticClass: "affiliate-pending-row"
    }, [_c('span', {
      staticClass: "affiliate-pending-email"
    }, [_vm._v(_vm._s(inv.email)), (inv.name) ? _c('span', [_vm._v(" (" + _vm._s(inv.name) + ")")]) : _vm._e(), (inv.status === 'failed') ? _c('span', {
      staticClass: "affiliate-pending-failed"
    }, [_vm._v(" · Couldn't join: has their own subscription")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "affiliate-pending-actions"
    }, [(inv.status !== 'failed') ? _c('button', {
      staticClass: "affiliate-link-btn",
      attrs: {
        "type": "button",
        "disabled": _vm.resendCooldown[inv.id]
      },
      on: {
        "click": function($event) {
          return _vm.resendInvite(inv)
        }
      }
    }, [_vm._v(_vm._s(_vm.resendCooldown[inv.id] ? 'Sent' : 'Resend'))]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "affiliate-link-btn affiliate-link-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.cancelInvite(inv)
        }
      }
    }, [_vm._v(_vm._s(inv.status === 'failed' ? 'Remove' : 'Cancel'))])])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.opened) ? _c('div', {
    staticClass: "affiliations-list"
  }, _vm._l((_vm.availableSlots), function(slotNumber) {
    return _c('affiliate-slot', {
      key: slotNumber,
      attrs: {
        "slotNumber": slotNumber,
        "affiliateUsers": _vm.affiliateUsers,
        "slotAffiliate": _vm.activeAffiliates[slotNumber - 2]
      },
      on: {
        "updateSlot": _vm.updateSlotAffiliate
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.opened) ? _c('div', {
    staticClass: "affiliate-roster",
    class: {
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "affiliate-roster-title"
  }, [_vm._v("Affiliated users")]), _vm._v(" "), (_vm.rosterUsers.length) ? _c('div', _vm._l((_vm.rosterUsers), function(ru) {
    return _c('div', {
      key: ru.uid,
      staticClass: "affiliate-roster-row"
    }, [_c('span', {
      staticClass: "affiliate-roster-name"
    }, [_vm._v(_vm._s(ru.label))]), _vm._v(" "), _c('span', {
      staticClass: "affiliate-roster-state",
      class: {
        'is-active': ru.active && !ru.selfPays,
        'is-self-pay': ru.selfPays
      },
      attrs: {
        "title": ru.selfPays ? 'This member pays for their own subscription, so they do not use one of your licenses.' : null
      }
    }, [_vm._v(_vm._s(ru.selfPays ? 'Own subscription' : (ru.active ? 'Active license' : 'Inactive')))]), _vm._v(" "), _c('button', {
      staticClass: "affiliate-link-btn affiliate-link-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeAffiliate(ru)
        }
      }
    }, [_vm._v("Remove")])])
  }), 0) : _c('p', {
    staticClass: "affiliate-roster-empty"
  }, [_vm._v("No one's affiliated yet — invite your team above.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "affiliations-footer",
    class: {
      'show-md-dark-mode': _vm.showMode,
      'is-adding-licenses': _vm.addLicenseToggle
    }
  }, [(!_vm.addLicenseToggle) ? _c('div', {
    staticClass: "affiliations-footer-total-license"
  }, [_vm._v("Total Licenses: " + _vm._s(_vm.licenseCount))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "add-licenses-button-container"
  }, [(!_vm.addLicenseToggle) ? _c('md-button', {
    staticClass: "md-raised is-ghost",
    on: {
      "click": _vm.addLicenses
    }
  }, [_vm._v("Adjust Total Licenses")]) : _vm._e(), _vm._v(" "), (!_vm.addLicenseToggle) ? _c('div', {
    staticClass: "footer-actions-right"
  }, [_c('md-button', {
    staticClass: "md-raised is-ghost",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": _vm.institution_name === ''
    },
    on: {
      "click": _vm.confirmChanges
    }
  }, [_vm._v("Confirm Changes")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "edit-your-institution-actions"
  }), _vm._v(" "), (_vm.addLicenseToggle) ? _c('div', {
    staticClass: "add-licenses-container"
  }, [_c('div', {
    staticClass: "add-licenses-text"
  }, [_c('div', [_vm._v("ADD ADDITIONAL USERS AT $" + _vm._s(_vm.seatPricePerYear.toFixed(2)) + " PER USER/PER YEAR")]), _vm._v(" "), (_vm.isDualMultiSeatPlan) ? _c('div', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "4px"
    }
  }, [_vm._v("\n                            Dual seat pricing. Seat holders must also be invited in The Notes List.\n                        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "add-licenses-buttons"
  }, [_c('md-button', {
    staticClass: "md-raised is-ghost is-icon",
    on: {
      "click": _vm.minusNewLicenses
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised is-ghost is-icon",
    on: {
      "click": _vm.plusNewLicenses
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.toggleConfirmPurchase
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised is-ghost",
    on: {
      "click": _vm.addLicenses
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('div', {
    staticClass: "add-licenses-text"
  }, [_c('div', [_vm._v("ADDITIONAL USERS: " + _vm._s(_vm.licensesToAdd) + "  ")]), _vm._v(" "), _c('div', [_vm._v("TOTAL USERS: " + _vm._s(_vm.newTotalLicenses))])])]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20010c55","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/manage-affiliation.vue
// module id = 1213
// module chunks = 21